import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCreditCard1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="credit-card-1, card, payment"><path d="M2 7.75293C2 5.68186 3.67893 4.00293 5.75 4.00293H18.2461C20.3172 4.00293 21.9961 5.68186 21.9961 7.75293L21.9955 9H2V7.75293Z" fill="currentColor"/><path d="M2 10.5V16.2461C2 18.3172 3.67893 19.9961 5.75 19.9961L18.2422 19.9961C20.3131 19.9961 21.9919 18.317 21.9922 16.2461L21.9948 10.5H2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCreditCard1;
